globalThis.cancelbubble = function cancelbubble(event) {
  event.stopPropagation();
};
